function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 21C4.5 21 .3 12.8.1 12.4c-.1-.3-.1-.6 0-.9C.3 11.2 4.5 3 12 3s11.7 8.2 11.9 8.6c.1.3.1.6 0 .9-.2.3-4.4 8.5-11.9 8.5zm-9.9-9c.9 1.6 4.5 7 9.9 7s8.9-5.4 9.9-7c-.9-1.6-4.5-7-9.9-7s-8.9 5.4-9.9 7z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 16c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
});

function SvgIconEye(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgdmlld0JveD0iMCAwIDI0IDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Im0xMiAyMWMtNy41IDAtMTEuNy04LjItMTEuOS04LjYtLjEtLjMtLjEtLjYgMC0uOS4yLS4zIDQuNC04LjUgMTEuOS04LjVzMTEuNyA4LjIgMTEuOSA4LjZjLjEuMy4xLjYgMCAuOS0uMi4zLTQuNCA4LjUtMTEuOSA4LjV6bS05LjktOWMuOSAxLjYgNC41IDcgOS45IDdzOC45LTUuNCA5LjktN2MtLjktMS42LTQuNS03LTkuOS03cy04LjkgNS40LTkuOSA3eiIvPjxwYXRoIGQ9Im0xMiAxNmMtMi4yIDAtNC0xLjgtNC00czEuOC00IDQtNCA0IDEuOCA0IDQtMS44IDQtNCA0em0wLTZjLTEuMSAwLTIgLjktMiAycy45IDIgMiAyIDItLjkgMi0yLS45LTItMi0yeiIvPjwvc3ZnPg==";
export { SvgIconEye as ReactComponent };